// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 553 ? "c2a7a40d" : chunkId) + "." + {"45":"6cda0624bf77577d","553":"dabbe94b648a4e0d"}[chunkId] + ".js";
};